import { Icon } from '@/shared/types/icon';

const Brand = ({ size = 32, color = 'var(--color-foreground-muted)', className = '' }: Icon) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <g fill={color} clipPath="url(#brand)">
        <path d="M13.602 3.488a2.933 2.933 0 1 0 0 5.866h5.866a2.933 2.933 0 1 0 0-5.866h-5.866ZM6.742 20.491a4.119 4.119 0 1 0 0-8.238 4.119 4.119 0 0 0 0 8.238ZM5.026 8.75a2.403 2.403 0 1 0 0-4.804 2.403 2.403 0 0 0 0 4.805ZM16.504 18.66a2.403 2.403 0 1 0 0-4.805 2.403 2.403 0 0 0 0 4.805Z" />
      </g>
      <defs>
        <clipPath id="brand">
          <path fill="#fff" d="M.5 0h24v24H.5z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Brand;
